import React, { useCallback, useMemo } from "react";
import { Platform, StyleSheet } from "react-native";

import { apple, facebook, google } from "../assets/images";
import { spacing } from "../styles";
import Block from "./Block";
import Button from "./Button";
import { Image } from "./Image";

type Props = {
  disabled?: boolean;
  type: "default" | "google" | "apple" | "facebook";
  onPress: () => void;
  t: ToDo;
};

const imageMapping = {
  google,
  apple,
  facebook,
} as const;

const SocialButton = ({ disabled, type, onPress, t }: Props) => {
  const isDefault = useMemo(() => type === "default", [type]);

  const leftComponent = useCallback(
    () =>
      isDefault ? null : (
        <Block style={styles.image}>
          <Image
            contentFit="contain"
            height={spacing.unit * 3}
            source={imageMapping[type as "apple"]}
            style={styles.image}
            width={spacing.unit * 3}
          />
        </Block>
      ),
    [isDefault, type],
  );

  return (
    <Button
      disabled={disabled}
      label={t("screens.login.social", { context: type })}
      leftComponent={leftComponent}
      onPress={onPress}
      style={styles.button}
      textStyle={!isDefault && styles.buttonText}
      type={isDefault ? "primary" : "secondary"}
    />
  );
};

export default React.memo(SocialButton);

const styles = StyleSheet.create({
  button: {
    minWidth: spacing.isBigScreen ? spacing.deviceWidth / 3 : "100%",
  },
  buttonText: {
    paddingLeft: spacing.unit * 2,
  },
  image: Platform.select({
    default: {
      height: spacing.unit * 4,
      width: spacing.unit * 4,
    },
    web: {
      height: spacing.unit * 3,
      width: spacing.unit * 3,
    },
  }),
});
